import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ProcedurePageContext} from 'procedures/ProcedurePageContext';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';
import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY, GRAY_DARKER, GRAY_LIGHT, NEAR_BLACK, WHITE} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {COMMON_NODE_WIDTH} from '../procedureMethodNodeCommonConsts';

export function ProcedureAddFirstMethodCard(props: {onClick: () => void}): JSX.Element {
  const {procedureMetadata} = ProcedurePageContext.useContext();
  const procedureType = procedureMetadata.procedureType;

  return (
    <div
      className={css(styles.backingBox)}
      {...getTestProps({component: 'ProcedureAddFirstMethodCard', element: 'root'})}
    >
      <p className={css(styles.descriptionText)}>
        {`Add ${getProcedureUIString(ProceduresStringKeys.METHOD, procedureType, {
          stringCase: StringCase.LOWER,
          prependAorAn: true,
        })} to get started`}
      </p>
      <div
        className={css(styles.buttonBox)}
        onClick={(e) => {
          e.stopPropagation();
          props.onClick();
        }}
      >
        <BenchlingIcon className={css(styles.plusSign)} icon="plus" />
        <div className={css(styles.addMethodText)}>
          {`Add ${getProcedureUIString(ProceduresStringKeys.METHOD, procedureType, {
            stringCase: StringCase.LOWER,
          })}`}
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  backingBox: {
    background: GRAY_LIGHT,
    border: '1px solid',
    borderColor: GRAY,
    borderRadius: '4px',
    borderStyle: 'dashed',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: `${COMMON_NODE_WIDTH}px`,
    height: '174px',
  },
  descriptionText: {
    fontSize: '14px',
    fontWeight: 400,
    color: NEAR_BLACK,
    lineHeight: '16px',
    textAlign: 'center',
    padding: '49px 42px 6px',
  },
  buttonBox: {
    background: WHITE,
    border: '1px solid',
    borderColor: GRAY,
    borderRadius: '4px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 10px',
  },
  plusSign: {
    color: GRAY_DARKER,
    width: '12px',
    height: '12px',
  },
  addMethodText: {
    fontSize: '13px',
    fontWeight: 600,
    color: GRAY_DARKER,
    lineHeight: '16px',
    paddingLeft: '4px',
  },
});
